import type { BooleanSettingConfig } from "./BooleanSettingRow";
import { SETTINGS_CATEGORY } from "./settingsCategories";

export const BOOLEAN_SETTINGS: BooleanSettingConfig[] = [
    {
        id: "uses_portal",
        title: "Allow beneficiary portal?",
        description: "Aka Espace auteur",
        category: SETTINGS_CATEGORY.Beneficiaries,
    },
    {
        id: "uses_beneficiary_documents_tracking",
        title: "Enable beneficiary documents tracking?",
        description:
            "Configurable document types with validity, beneficiaries × documents table view and bulk reminder emails. Seeds 2 default types on activation.",
        category: SETTINGS_CATEGORY.Beneficiaries,
    },
    {
        id: "uses_scoped_notifications",
        title: "Enable scoped notifications",
        description: "Will add a new settings page to choose the roles that can receive scoped notifications",
        category: SETTINGS_CATEGORY.Beneficiaries,
    },
    {
        id: "uses_beneficiary_profile_complete_check",
        title: "Mark a beneficiary profile as completed",
        description:
            "Will add a checkbox to mark a beneficiary profile as completed on the beneficiary page. Any beneficiary whose profile is not marked as completed will not be included in payments and accounting exports.",
        category: SETTINGS_CATEGORY.Beneficiaries,
    },
    {
        id: "uses_twenty_percent_vat",
        title: "Show beneficiaries 20% VAT option",
        description: "In beneficiary form vat list option, will show twenty percent vat choice",
        category: SETTINGS_CATEGORY.Beneficiaries,
    },
    {
        id: "uses_accountant_mail_remind",
        title: "Press/Audio Daily send email remind listing unpaid articles/services to users with role accountant",
        description:
            'Accountants will receive a daily summary email with the list of unpaid articles/services. The conditions are as follows: The beneficiary profile must be marked as "complete", the article/service must be in "completed" and "unpaid" status.',
        category: SETTINGS_CATEGORY.Beneficiaries,
    },

    {
        id: "enforce_mfa",
        title: "Make MFA mandatory to access company",
        description: "Will require MFA activation to every account attached to this company",
        category: SETTINGS_CATEGORY.Enterprise,
    },
    {
        id: "uses_custom_roles",
        title: "Enable Custom Roles & Permissions",
        description:
            "Will add a new settings page for managing custom roles and granular permissions for team members.",
        category: SETTINGS_CATEGORY.Enterprise,
    },

    {
        id: "uses_multiple_brands",
        title: "Allow multiple brand?",
        description: "Will show a tab in settings and option in title",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "uses_metadata",
        title: "Enable metadata (title and beneficiary) on company",
        description: "Will add pages in settings to add custom fields and save them on title/beneficiary",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "uses_multiple_currencies",
        title: "Enable multiple currencies? (only for EUR-based companies for now)",
        description: "Will add currency options on title",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "uses_price_with_vat",
        title: "Enable price with vat?",
        description: "Adding titles price in vat",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "uses_market_segmentation",
        title: "Enable country market segmentation",
        description: "Will add an option on title to assign country code for sales",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "uses_cumulative_royalties",
        title: "Use cumulative royalties field (droits cumulés) on term",
        description: "Will add cumulative royalties field on form for term creation and display info on statement.",
        category: SETTINGS_CATEGORY.Titles,
    },
    {
        id: "show_title_consolidated_sales",
        title: "Show consolidated sales on title page",
        description: "Shows tab on title page with consolidated data per channel category.",
        category: SETTINGS_CATEGORY.Titles,
    },

    {
        id: "uses_agreements",
        title: "Enable agreements signature for books?",
        description: "Will give the possibility to sign contracts electronically (via Crealo Sign by default)",
        category: SETTINGS_CATEGORY.Contracts,
    },
    {
        id: "display_agreement_public_id",
        title: "Display agreement public id column on /agreements?",
        description:
            'Will show the agreement human-readable public id (e.g. AGRK7XP2M5847) as a column on the agreements page. Requires "Enable agreements signature for books" to be enabled.',
        category: SETTINGS_CATEGORY.Contracts,
    },
    {
        id: "uses_agreement_validation_chain",
        title: "Enable agreements validation chain ?",
        description: "Will add validation process to agreements signature and a new page",
        category: SETTINGS_CATEGORY.Contracts,
    },
    {
        id: "uses_transfer_term",
        title: "Show Rights Transfer pages",
        description: "Company can create transferees (with Transferees page) and manage transfer terms.",
        category: SETTINGS_CATEGORY.Contracts,
    },
    {
        id: "uses_initial_advance",
        title: "Display initial advance?",
        description: "Will add input in term form and display info on statement",
        category: SETTINGS_CATEGORY.Contracts,
    },
    {
        id: "press_agreements_detach_statements",
        title: "Detach statement from contract on press/audiovisual company",
        description: "Don't attach statements as “attachments” when signing the contract",
        category: SETTINGS_CATEGORY.Contracts,
    },

    {
        id: "uses_stock",
        title: "Show stock feature?",
        description: "Shows stock tab in /management and stock options in settings",
        category: SETTINGS_CATEGORY.Sales,
    },
    {
        id: "uses_overriden_price_on_sales",
        title: "Allow price on sales?",
        description: "Will add price field on sales.",
        category: SETTINGS_CATEGORY.Sales,
    },
    {
        id: "press_uses_multiple_channels",
        title: "Does press company use both folio and amount payments?",
        description: "Will display selector on article creation (and other changes).",
        category: SETTINGS_CATEGORY.Sales,
    },
    {
        id: "uses_distributor_sales_data",
        title: "Enable distributor sales data",
        description:
            "Will add distributorGrossPrice and distributorInvoicingPercentage fields on add sales. Note: Rosie has this company settings activated + Bexio active integration.",
        category: SETTINGS_CATEGORY.Sales,
    },
    {
        id: "allows_subscription_channels",
        title: "Allow subscription channels",
        description:
            "Will enable the subscription calculation method in channel creation and subscription management modal.",
        category: SETTINGS_CATEGORY.Sales,
    },

    {
        id: "uses_interchannel_compensation",
        title: "Enable inter-channel compensation?",
        description: "Will show compensation groups in channel creation, ...",
        category: SETTINGS_CATEGORY.Compensations,
    },
    {
        id: "uses_interterm_compensation",
        title: "Enable inter-term (advance) compensation?",
        description: "Will show compensation groups selector on term creation",
        category: SETTINGS_CATEGORY.Compensations,
    },
    {
        id: "uses_intertitle_compensation",
        title: "Enable inter-title compensation?",
        description: "Will show compensation groups selector on title creation",
        category: SETTINGS_CATEGORY.Compensations,
    },
    {
        id: "always_pay_collective_and_other",
        title: "Always pay collective management and other?",
        description:
            "Whatever the status of the advance nor other channels, these two kinds will always be in grossDuty",
        info: "⚠️ You have to update each term manually by adding a sales to it.",
        category: SETTINGS_CATEGORY.Compensations,
    },
    {
        id: "hide_sales_zero_percent_term",
        title: "Hide sales from Management details if term has 0% on channel",
        description: "Will hide sales that do not belong to this term (zero percent channel)",
        category: SETTINGS_CATEGORY.Compensations,
    },

    {
        id: "uses_custom_statement_templates",
        title: "Enable custom statement templates?",
        description: "Will show the custom statement templates tab",
        category: SETTINGS_CATEGORY.Statements,
    },
    {
        id: "uses_simultaneous_period",
        title: "Enable multiple period type ?",
        description: "Contact dev team if you plan to add more period types",
        category: SETTINGS_CATEGORY.Statements,
    },
    {
        id: "beneficiary_merged_statements_enabled",
        title: "Enable download of merged consolidated/gross statements",
        description: "Will add a new download button on management/beneficiary page for download a merged statement",
        category: SETTINGS_CATEGORY.Statements,
    },
    {
        id: "show_type_1_2_as_compensated_statement",
        title: "Show type 1/2 statements as compensated",
        description: "Will display all statements as tables.",
        category: SETTINGS_CATEGORY.Statements,
    },
    {
        id: "hidden_stock_lines_on_statement",
        title: "Hide stock lines on statement",
        description: "Will hide selected stock lines on statement.",
        category: SETTINGS_CATEGORY.Statements,
    },

    {
        id: "uses_minimum_guaranteed_payment",
        title: 'Show "minimum guaranteed" option on press/audio',
        description: 'Will add "minimum guaranteed" option for article/service payment method',
        category: SETTINGS_CATEGORY.Payments,
    },
    {
        id: "international_banking_enabled",
        title: "Enable international payment files",
        description:
            "Allows defining international banking details for beneficiaries, independently of the company's country. Required to generate international payment files.",
        category: SETTINGS_CATEGORY.Payments,
    },
    {
        id: "intl_payment_batch_booking",
        title: "Batch booking for international payment files",
        description:
            "When enabled, all transactions in an international payment file are booked as a single debit (BtchBookg: true). Disabled by default.",
        category: SETTINGS_CATEGORY.Payments,
    },

    {
        id: "uses_accounting_with_channel_dispatch",
        title: "Does accounting use filters?",
        description: "Adds layer of complexity to accounting with filters options.",
        category: SETTINGS_CATEGORY.Payments,
    },
    {
        id: "uses_urssaf_declarations",
        title: "Show URSSAF declarations page?",
        description: "Will add Declarations tab to navbar and enable /declarations route",
        category: SETTINGS_CATEGORY.Payments,
    },
    {
        id: "uses_ircec",
        title: "Activate IRCEC on press/audiovisual company",
        description: "Company can define services and attach specific IRCEC rate to each service..",
        category: SETTINGS_CATEGORY.Payments,
    },

    {
        id: "uses_interforum_edi",
        title: "Enable Interforum EDI",
        description: "Will add a new settings page Interforum to show handled EDI files. (.edi, .csv)",
        category: SETTINGS_CATEGORY.Enterprise,
    },
    {
        id: "uses_worker_mode",
        title: "Activate asynchronous uploads.",
        description: "Uploads files asynchronously through bucket.",
        category: SETTINGS_CATEGORY.Enterprise,
    },

    {
        id: "uses_analytics",
        title: "Enable Analytics screen",
        description: "Will add Analytics button to navbar",
        category: SETTINGS_CATEGORY.Enterprise,
    },
];

/** Settings that need extra content rendered below them */
export const SETTINGS_WITH_EXTRA_CONTENT = new Set([
    "uses_multiple_currencies",
    "hidden_stock_lines_on_statement",
    "beneficiary_merged_statements_enabled",
]);
